const init = () => {
  const setUpAccordion = () => {
    const details = document.querySelectorAll(".js-faqItem");
    const RUNNING_VALUE = "running";
    const IS_OPENED_CLASS = "is-open";

    details.forEach((element) => {
      const summary = element.querySelector(".js-faqQuestion");
      const content = element.querySelector(".js-faqAnswer");

      summary.addEventListener("click", (event) => {
        event.preventDefault();

        if (element.dataset.animStatus === RUNNING_VALUE) {
          return;
        }

        if (element.open) {
          element.classList.toggle(IS_OPENED_CLASS);
          const closingAnim = content.animate(closingAnimKeyframes(content), animTiming);
          element.dataset.animStatus = RUNNING_VALUE;

          closingAnim.onfinish = () => {
            element.removeAttribute("open");
            element.dataset.animStatus = "";
          };
        } else {
          element.setAttribute("open", "true");
          element.classList.toggle(IS_OPENED_CLASS);

          const openingAnim = content.animate(openingAnimKeyframes(content), animTiming);
          element.dataset.animStatus = RUNNING_VALUE;

          openingAnim.onfinish = () => {
            element.dataset.animStatus = "";
          };
        }
      });
    });
  }

  const animTiming = {
    duration: 200,
    easing: "ease-in-out"
  };

  const closingAnimKeyframes = (content) => [
    {
      height: content.offsetHeight + 'px',
    }, {
      height: 0,
    }
  ];

  const openingAnimKeyframes = (content) => [
    {
      height: 0,
    }, {
      height: content.offsetHeight + 'px'
    }
  ];

  setUpAccordion();
}

export {
  init
}
